import { useState, useEffect } from 'react'
import { Input, Divider, Button, Modal, Typography, Select } from 'antd'
import SectionSurvivalZone from './sectionsurvivalzone'
const { Search } = Input

const SurvivalZone = () => {
  const [searchTerm, setSearchTerm] = useState('')

  const handleSearch = (term) => {
    setSearchTerm(term)
  }

  return (
    <>
      <div className="container">
        <Search
          placeholder="Search by name"
          onSearch={handleSearch}
          style={{ width: '16.5%' }}
          allowClear
        />
      </div>
      <Divider style={{ margin: '10px 0' }} />
      <div className="sections-container">
        <SectionSurvivalZone searchTerm={searchTerm} />
      </div>
    </>
  )
}

export default SurvivalZone
